import React, { CSSProperties, Dispatch, useEffect, useState } from 'react';
import {
  Backdrop,
  Button,
  Fade,
  Grid,
  IconButton,
  makeStyles,
} from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import { List } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { Iobject } from 'main_type';
import { userTypeList } from 'main_consts';
import Input from '../Material/Input';
import { inputChange, option2Trans } from '../../main_func';
import { VcGrid, EvenlyGrid } from '../Grid';
import Select, { Ioption } from '../Material/Select';
import {
  getUserInfoRedux,
  getWareHouseListRedux,
} from '../../reducers/shareData/selector';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    // width: 300,
    // height: 200,
    display: 'flex',
    flexDirection: 'column',
  },
}));

interface IWarehouseModal {
  inputName?: string;
  value: string;
  updateData: (x: Iobject) => void;
  style?: CSSProperties;
  setStatus?: Dispatch<React.SetStateAction<string>>;
  required?: boolean;
}

const WarehouseModal = (props: IWarehouseModal): JSX.Element => {
  const warehouseRedux = useSelector(getWareHouseListRedux);
  const userInfo = useSelector(getUserInfoRedux);

  const {
    inputName = 'warehouse',
    value,
    style,
    updateData,
    setStatus,
    required = false,
  } = props;

  const [open, setOpen] = useState(false);
  const [selectedVal, setSelectedVal] = useState('');
  const [option, setOption] = useState<Ioption[]>([]);
  const [transOptions] = option2Trans(option);

  const classes = useStyles();
  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onOkClick = (v: string) => {
    if (v.trim().length <= 0) {
      return;
    }
    const val: {
      locationCode: string;
      chkCode1: string;
      locationName: string;
    } = JSON.parse(v);

    const data: Iobject = {};
    data[inputName] = val.locationCode;
    if (setStatus) {
      setStatus(val.locationName);
    }
    // 承攬業者=>記帳代號的預設值
    if (userTypeList.type2.some((type) => type === userInfo.userType)) {
      data.chkCode1 = val.chkCode1;
    }

    updateData(data);
    setOpen(false);
  };

  const init = () => {
    if (warehouseRedux && warehouseRedux.length > 0) {
      setOption(
        warehouseRedux.map((v) => ({
          label: `${v.locationName}(${v.locationCode})`,
          value: JSON.stringify({
            locationCode: v.locationCode,
            chkCode1: v.chkCode1,
            locationName: v.locationName,
          }),
        }))
      );
      // 承攬業者 - 預設值
      if (userTypeList.type2.some((type) => type === userInfo.userType)) {
        const data = JSON.stringify({
          locationCode: warehouseRedux[0].locationCode || '',
          chkCode1: warehouseRedux[0].chkCode1 || '',
          locationName: warehouseRedux[0].locationName || '',
        });
        setSelectedVal(data);
        onOkClick(data);
      }
    }
  };

  useEffect(() => {
    init();
    if (setStatus || false) {
      const data = warehouseRedux.filter((v) => v.locationCode === value);
      setStatus(data[0]?.locationName);
    }
  }, [warehouseRedux]);

  return (
    <>
      <Grid container>
        <VcGrid item xs>
          <Input
            required={required}
            name={inputName}
            value={value}
            style={style}
            // required={required}
            disabled={
              userTypeList.type1.some((v) => v === userInfo.userType) ||
              userTypeList.type2.some((v) => v === userInfo.userType) ||
              userTypeList.type8.some((v) => v === userInfo.userType) ||
              userTypeList.type9.some((v) => v === userInfo.userType) ||
              userTypeList.type10.some((v) => v === userInfo.userType) ||
              (userTypeList.type4.some((v) => v === userInfo.userType) &&
                !userInfo.locationCode)
            }
            maxLength={8}
            InputProps={{
              endAdornment: (
                <IconButton
                  disabled={
                    userTypeList.type1.some((v) => v === userInfo.userType) ||
                    userTypeList.type2.some((v) => v === userInfo.userType) ||
                    userTypeList.type9.some((v) => v === userInfo.userType) ||
                    userTypeList.type8.some((v) => v === userInfo.userType) ||
                    userTypeList.type10.some((v) => v === userInfo.userType) ||
                    (userTypeList.type4.some((v) => v === userInfo.userType) &&
                      !userInfo.locationCode)
                  }
                  onClick={handleOpen}
                  type="button"
                >
                  <List />
                </IconButton>
              ),
            }}
            onChange={inputChange(updateData)}
          />
        </VcGrid>
      </Grid>

      <Modal
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        disableBackdropClick
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <Grid container>
              <VcGrid item xs={12}>
                快遞倉站清單：
              </VcGrid>
              <Grid item xs={12}>
                <Select
                  // placeholder="快遞倉站清單"
                  value={selectedVal}
                  onChange={(e) => {
                    setSelectedVal(e.target.value);
                  }}
                  options={transOptions}
                />
              </Grid>
            </Grid>
            <Grid container>
              <EvenlyGrid item xs style={{ margin: '1em 0' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    onOkClick(selectedVal);
                  }}
                >
                  確定
                </Button>
                <Button variant="contained" onClick={() => setOpen(false)}>
                  取消
                </Button>
              </EvenlyGrid>
            </Grid>
          </div>
        </Fade>
      </Modal>
    </>
  );
};
export default WarehouseModal;
